import { type FC, useMemo } from 'react';

import { type DateValue } from '@vakantiesnl/components/src/atoms/DatePicker/DatePicker.types';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { message } from '@vakantiesnl/components/src/utils/message';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import dayjs from 'dayjs';

import { useCustomStyles } from './DepartureRangeConfirmation.style';
import { getIsValidDateRange } from './utils';

export type Props = {
	/** The range of the calendar that is selected */
	dateRange: DateValue['value'];
};

export const DepartureRangeConfirmation: FC<Props> = ({ dateRange }): JSX.Element => {
	const microCopies = useMicroCopyContext();
	const { classes } = useCustomStyles();

	const isValidDateRange = useMemo(() => getIsValidDateRange(dateRange), [dateRange]);

	return (
		<Typography variant="bodySm" as="div" className={classes.wrapper}>
			{isValidDateRange
				? message(microCopies['departurerangeconfirmation.date'], {
						startDate: dayjs(dateRange[0]).format('D MMMM'),
						endDate: dayjs(dateRange[1]).format('D MMMM'),
					})
				: microCopies['departurerangeconfirmation.noDate']}
		</Typography>
	);
};
